var map = {
	"./Celery.png": "03e4",
	"./Crustaceans.png": "a669",
	"./Eggs.png": "4fa4",
	"./Fish.png": "2eb4",
	"./Gluten.png": "fa8d",
	"./Lupin.png": "9ff4",
	"./Milk.png": "3ab9",
	"./Molluscs.png": "fc21",
	"./Mustard.png": "5cbf",
	"./Nuts.png": "d501",
	"./Peanuts.png": "be26",
	"./Sesame seeds.png": "616a",
	"./Soy.png": "e2ab",
	"./Sulphur dioxide.png": "ab15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8885";